import React, { useRef, useState } from "react"
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import ReportHeader from "../component/report-header/ReportHeader";
import AHMIS, { API_URL } from "../../../api/api";
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import AddAlertMessage from "../../../components/alert/Alert";
import MessageBlock from "../../admin/components/message-block/MessageBlock";

const OutPatientReport = () => {

  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.outPatientReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url).then(response => {
      const jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        setTableData(jsondata.data);
      } else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
    });
  };

  return (
    <>
      <ReportHeader
        title="बहिरंग सेवा विवरण"
        getReportData={getReportData}
        reportData={Boolean(tableData)}
        printComponentRef={printComponentRef}
      />
      {tableData ? (
        <Box ref={printComponentRef}>
          <TableContainer>
            <Typography variant="body1" className="report-heading">७. बहिरंग सेवा विवरण</Typography>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Out-Patient-Report">
              <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                <TableRow>
                  <TableCell> क्र.सं. </TableCell>
                  <TableCell>ICD11</TableCell>
                  <TableCell>रोग</TableCell>
                  <TableCell>महिला</TableCell>
                  <TableCell>पुरुष</TableCell>
                  <TableCell>अन्य</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Jwar (Fever)</TableCell>
                  <TableCell>{tableData["1"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["1"]?.MALE}</TableCell>
                  <TableCell>{tableData["1"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Swash vikar (Respiratory disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>2.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Swash (Asthm and COAD)</TableCell>
                  <TableCell>{tableData["2"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["2"]?.MALE}</TableCell>
                  <TableCell>{tableData["2"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>2.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kas(Coughing disorder)</TableCell>
                  <TableCell>{tableData["3"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["3"]?.MALE}</TableCell>
                  <TableCell>{tableData["3"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>2.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["4"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["4"]?.MALE}</TableCell>
                  <TableCell>{tableData["4"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Amlapitta (APD)</TableCell>
                  <TableCell>{tableData["5"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["5"]?.MALE}</TableCell>
                  <TableCell>{tableData["5"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Atisar/Grahani (Diarrhoea/IBS)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Atisar (Diarrhoea)</TableCell>
                  <TableCell>{tableData["6"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["6"]?.MALE}</TableCell>
                  <TableCell>{tableData["6"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Grahani (IBS,IBD,Ulcerative colitis, Crohn's disease, Sprue)</TableCell>
                  <TableCell>{tableData["7"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["7"]?.MALE}</TableCell>
                  <TableCell>{tableData["7"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pravahika (Dysnetry)</TableCell>
                  <TableCell>{tableData["8"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["8"]?.MALE}</TableCell>
                  <TableCell>{tableData["8"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>4.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["9"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["9"]?.MALE}</TableCell>
                  <TableCell>{tableData["9"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>5</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Udarroga (Abdominal disorder)</TableCell>
                  <TableCell>{tableData["10"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["10"]?.MALE}</TableCell>
                  <TableCell>{tableData["10"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>6</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Prameha/Madhumeha</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>6.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Prameha</TableCell>
                  <TableCell>{tableData["11"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["11"]?.MALE}</TableCell>
                  <TableCell>{tableData["11"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>6.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Madhumeha (Diabetes mellitus)</TableCell>
                  <TableCell>{tableData["12"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["12"]?.MALE}</TableCell>
                  <TableCell>{tableData["12"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>7</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kamala</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>7.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kosthashrita kamala (Non obstructive jaundice)</TableCell>
                  <TableCell>{tableData["13"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["13"]?.MALE}</TableCell>
                  <TableCell>{tableData["13"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>7.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Shakhashrita kamala (Obstructive jaundice)</TableCell>
                  <TableCell>{tableData["14"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["14"]?.MALE}</TableCell>
                  <TableCell>{tableData["14"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>8</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pandu (Anaemia)</TableCell>
                  <TableCell>{tableData["15"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["15"]?.MALE}</TableCell>
                  <TableCell>{tableData["15"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>9</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Hridaya roga (Cardiac disorder)</TableCell>
                  <TableCell>{tableData["16"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["16"]?.MALE}</TableCell>
                  <TableCell>{tableData["16"]?.OTHER}</TableCell>

                </TableRow>
                <TableRow>
                  <TableCell>10</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Raktachap (Blood pressure disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>10.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Uchharaktachap (Hypertension)</TableCell>
                  <TableCell>{tableData["17"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["17"]?.MALE}</TableCell>
                  <TableCell>{tableData["17"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>10.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Nyunaraktachap (Hypotension)</TableCell>
                  <TableCell>{tableData["18"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["18"]?.MALE}</TableCell>
                  <TableCell>{tableData["18"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>11</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Shotha (Oedema)</TableCell>
                  <TableCell>{tableData["19"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["19"]?.MALE}</TableCell>
                  <TableCell>{tableData["19"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>12</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Krimi (Worm infestation)</TableCell>
                  <TableCell>{tableData["20"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["20"]?.MALE}</TableCell>
                  <TableCell>{tableData["20"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>13</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Twak vikar (Skin disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>13.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Ekkustha/Kitibha (Psoriasis)</TableCell>
                  <TableCell>{tableData["21"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["21"]?.MALE}</TableCell>
                  <TableCell>{tableData["21"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>13.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pama </TableCell>
                  <TableCell>{tableData["22"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["22"]?.MALE}</TableCell>
                  <TableCell>{tableData["22"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>13.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vyanga/Nyachha (Blemishes)</TableCell>
                  <TableCell>{tableData["23"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["23"]?.MALE}</TableCell>
                  <TableCell>{tableData["23"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>13.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell> Others</TableCell>
                  <TableCell>{tableData["24"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["24"]?.MALE}</TableCell>
                  <TableCell>{tableData["24"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>14</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vrana (Wound/ulcer)</TableCell>
                  <TableCell>{tableData["25"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["25"]?.MALE}</TableCell>
                  <TableCell>{tableData["25"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>15</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Abhighataj vikar (Traumatic disorder)</TableCell>
                  <TableCell>{tableData["26"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["26"]?.MALE}</TableCell>
                  <TableCell>{tableData["26"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vata vyadhi (Skeleto-muscular and nervous system disease)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Manyastambha (Torticollis)</TableCell>
                  <TableCell>{tableData["27"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["27"]?.MALE}</TableCell>
                  <TableCell>{tableData["27"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Avabahuka (Frozen shoulder)</TableCell>
                  <TableCell>{tableData["28"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["28"]?.MALE}</TableCell>
                  <TableCell>{tableData["28"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vishwachi (Cervical spodylosis)</TableCell>
                  <TableCell>{tableData["29"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["29"]?.MALE}</TableCell>
                  <TableCell>{tableData["29"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Katishula (Lumbago)</TableCell>
                  <TableCell>{tableData["30"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["30"]?.MALE}</TableCell>
                  <TableCell>{tableData["30"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.5</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Gridhasi (Sciatica)</TableCell>
                  <TableCell>{tableData["31"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["31"]?.MALE}</TableCell>
                  <TableCell>{tableData["31"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.6</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Sandhivata (Osteoarthritis)</TableCell>
                  <TableCell>{tableData["32"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["32"]?.MALE}</TableCell>
                  <TableCell>{tableData["32"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.7</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Angamarda (Bodyache)</TableCell>
                  <TableCell>{tableData["33"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["33"]?.MALE}</TableCell>
                  <TableCell>{tableData["33"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.8</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pakshaghat (Paralysis)</TableCell>
                  <TableCell>{tableData["34"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["34"]?.MALE}</TableCell>
                  <TableCell>{tableData["34"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.9</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kampavata (Parkinson)</TableCell>
                  <TableCell>{tableData["35"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["35"]?.MALE}</TableCell>
                  <TableCell>{tableData["35"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.10</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mamsagata vata (Muscular dystrophy)</TableCell>
                  <TableCell>{tableData["36"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["36"]?.MALE}</TableCell>
                  <TableCell>{tableData["36"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>16.11</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["37"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["37"]?.MALE}</TableCell>
                  <TableCell>{tableData["37"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>17</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Amavata (Rheumatoid arthritis)</TableCell>
                  <TableCell>{tableData["38"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["38"]?.MALE}</TableCell>
                  <TableCell>{tableData["38"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>18</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Twak vikar (Skin disorder)</TableCell>
                  <TableCell>{tableData["39"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["39"]?.MALE}</TableCell>
                  <TableCell>{tableData["39"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>18</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Vatrakta (Gout)</TableCell>
                  <TableCell>{tableData["40"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["40"]?.MALE}</TableCell>
                  <TableCell>{tableData["40"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>19</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Raktavikar (Blood disorder)</TableCell>
                  <TableCell>{tableData["48"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["48"]?.MALE}</TableCell>
                  <TableCell>{tableData["48"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>20</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mutravikar (Urinary disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>20.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mutrasmari (Renal calculi)</TableCell>
                  <TableCell>{tableData["41"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["41"]?.MALE}</TableCell>
                  <TableCell>{tableData["41"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>20.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mutrakrichhra (Dysuria)</TableCell>
                  <TableCell>{tableData["42"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["42"]?.MALE}</TableCell>
                  <TableCell>{tableData["42"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>20.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mutraghat (Retnetion/suppression of urine)</TableCell>
                  <TableCell>{tableData["43"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["43"]?.MALE}</TableCell>
                  <TableCell>{tableData["43"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>21</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Prasutivikar (Postpartum disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>21.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Stanya vikar (Breast milk dosorder)</TableCell>
                  <TableCell>{tableData["44"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["44"]?.MALE}</TableCell>
                  <TableCell>{tableData["44"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>21.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Garbhashayachhyuta (Uterine prolapse)</TableCell>
                  <TableCell>{tableData["45"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["45"]?.MALE}</TableCell>
                  <TableCell>{tableData["45"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>21.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["46"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["46"]?.MALE}</TableCell>
                  <TableCell>{tableData["46"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>22</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Striroga (Gynaecological disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>22.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Raktapradar (Menstrual problem)</TableCell>
                  <TableCell>{tableData["47"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["47"]?.MALE}</TableCell>
                  <TableCell>{tableData["47"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>22.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Swetapradar (Leucorrhoea)</TableCell>
                  <TableCell>{tableData["48"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["48"]?.MALE}</TableCell>
                  <TableCell>{tableData["48"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>22.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kashtartawa (Dysmenorrhoea)</TableCell>
                  <TableCell>{tableData["49"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["49"]?.MALE}</TableCell>
                  <TableCell>{tableData["49"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>22.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Anartawa (Amenorrhoea)</TableCell>
                  <TableCell>{tableData["50"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["50"]?.MALE}</TableCell>
                  <TableCell>{tableData["50"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>22.5</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Yoniroga (…..)</TableCell>
                  <TableCell>{tableData["51"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["51"]?.MALE}</TableCell>
                  <TableCell>{tableData["51"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>22.6</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["52"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["52"]?.MALE}</TableCell>
                  <TableCell>{tableData["52"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>23</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Gudavikar</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>23.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Arsha (Haemorrhoids)</TableCell>
                  <TableCell>{tableData["53"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["53"]?.MALE}</TableCell>
                  <TableCell>{tableData["53"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>23.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Bhagandar (Fistula in ano)</TableCell>
                  <TableCell>{tableData["54"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["54"]?.MALE}</TableCell>
                  <TableCell>{tableData["54"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>23.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Pilonidal sinus</TableCell>
                  <TableCell>{tableData["55"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["55"]?.MALE}</TableCell>
                  <TableCell>{tableData["55"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>23.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Perianal wart</TableCell>
                  <TableCell>{tableData["56"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["56"]?.MALE}</TableCell>
                  <TableCell>{tableData["56"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>23.5</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Parikartika (Fissure)</TableCell>
                  <TableCell>{tableData["57"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["57"]?.MALE}</TableCell>
                  <TableCell>{tableData["57"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>23.6</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["58"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["58"]?.MALE}</TableCell>
                  <TableCell>{tableData["58"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>24</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Netraroga (Ophthamological disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>24.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Abhisyandi (Conjunctivitis)</TableCell>
                  <TableCell>{tableData["59"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["59"]?.MALE}</TableCell>
                  <TableCell>{tableData["59"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>24.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Athimantha (Glaucoma)</TableCell>
                  <TableCell>{tableData["60"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["60"]?.MALE}</TableCell>
                  <TableCell>{tableData["60"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>24.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Timira (Cataract)</TableCell>
                  <TableCell>{tableData["61"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["61"]?.MALE}</TableCell>
                  <TableCell>{tableData["61"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>24.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["62"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["62"]?.MALE}</TableCell>
                  <TableCell>{tableData["62"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>25</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Karna-nasa-mukha-danta-kantha roga</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>25.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Karna roga (Disease related to ear)</TableCell>
                  <TableCell>{tableData["63"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["63"]?.MALE}</TableCell>
                  <TableCell>{tableData["63"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>25.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Nasa roga (Disease related to nose)</TableCell>
                  <TableCell>{tableData["64"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["64"]?.MALE}</TableCell>
                  <TableCell>{tableData["64"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>24</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Mukha roga (Oral disease)</TableCell>
                  <TableCell>{tableData["65"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["65"]?.MALE}</TableCell>
                  <TableCell>{tableData["65"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>25.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Danta roga(Dental disease)</TableCell>
                  <TableCell>{tableData["66"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["66"]?.MALE}</TableCell>
                  <TableCell>{tableData["66"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>25.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Kantha roga (Disease related to throat)</TableCell>
                  <TableCell>{tableData["67"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["67"]?.MALE}</TableCell>
                  <TableCell>{tableData["67"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>26</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Shiroroga (Disease related to head)</TableCell>
                  <TableCell>{tableData["68"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["68"]?.MALE}</TableCell>
                  <TableCell>{tableData["68"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>27</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Manasvikar (Psychological disorder)</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>27.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Apasmar (Epilepsy)</TableCell>
                  <TableCell>{tableData["69"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["69"]?.MALE}</TableCell>
                  <TableCell>{tableData["69"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>27.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Unmad (Neurosis)</TableCell>
                  <TableCell>{tableData["70"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["70"]?.MALE}</TableCell>
                  <TableCell>{tableData["70"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>27.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Atatwavinesh (Psychosis)</TableCell>
                  <TableCell>{tableData["71"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["71"]?.MALE}</TableCell>
                  <TableCell>{tableData["71"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>27.4</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["72"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["72"]?.MALE}</TableCell>
                  <TableCell>{tableData["72"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>28</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Balroga (Paediatric disorder)</TableCell>
                  <TableCell>{tableData["73"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["73"]?.MALE}</TableCell>
                  <TableCell>{tableData["73"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>29</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Jarajanya vikar (Geriatric problem)</TableCell>
                  <TableCell>{tableData["74"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["74"]?.MALE}</TableCell>
                  <TableCell>{tableData["74"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>30</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Anya/vividha</TableCell>
                  <TableCell colSpan={3}></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>30.1</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Granthi/Arbuda roga (Tumor/cancer)</TableCell>
                  <TableCell>{tableData["75"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["75"]?.MALE}</TableCell>
                  <TableCell>{tableData["75"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>30.2</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Antashrabi granthi janya roga (Hormonal disorder) </TableCell>
                  <TableCell>{tableData["76"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["76"]?.MALE}</TableCell>
                  <TableCell>{tableData["76"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>30.3</TableCell>
                  <TableCell></TableCell>
                  <TableCell>Others</TableCell>
                  <TableCell>{tableData["77"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["77"]?.MALE}</TableCell>
                  <TableCell>{tableData["77"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={3}>नयाँ सेवाग्राही जम्मा</TableCell>
                  <TableCell>{tableData["NEW_PATIENT"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["NEW_PATIENT"]?.MALE}</TableCell>
                  <TableCell>{tableData["NEW_PATIENT"]?.OTHER}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={3}>दोहोरिएको सेवाग्राही जम्मा</TableCell>
                  <TableCell>{tableData["PREVIOUS_PATIENT"]?.FEMALE}</TableCell>
                  <TableCell>{tableData["PREVIOUS_PATIENT"]?.MALE}</TableCell>
                  <TableCell>{tableData["PREVIOUS_PATIENT"]?.OTHER}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  )
}

export default OutPatientReport;